<template>
  <div id="expenses-details" class="wrrapper">
    <page-heading
      :title="
        `${
          patinetDetails && patinetDetails.name ? patinetDetails.name : ''
        } Ledger`
      "
      back
    >
      <template #content>
        <div class="flex align-center no-print">
          <DateRangePicker @update="handleDateRange" />
          <ExportButtons @pdf="handleExportPdf" @excel="handleExportExcel" />
        </div>
      </template>
    </page-heading>
    <div id="expense-details">
      <data-table
        :cols="columns"
        :rows="reportLedger"
        height="calc(100vh - 14.5rem)"
      >
        <template slot="action" slot-scope="actions">
          <dropdown-menu
            v-if="actions.actions.status === 1"
            :rowData="actions"
            :items="['Paid']"
            :handleItemClick="handleRecieveables"
          />
        </template>
      </data-table>
    </div>
    <ConfirmDialog
      name="confirmModal"
      title="Process patient"
      message="Are you sure you want to process this patient?"
      confirm-text="Yes, process"
      cancel-text="Cancel"
      @confirm="handleSave"
      @cancel="handleCancel"
    />
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import DateRangePicker from "@/components/DateRangePIcker";
import DropdownMenu from "@/components/DropdownMenu";
import ConfirmDialog from "@/components/ConfirmDialog";
import ExportButtons from "@/components/ExportButtons.vue";
import { exportReportPdf, exportReportExcel } from "@/utils/reportExport";
import { formatedDate } from "@/utils/helpers";
import { mapGetters, mapActions } from "vuex";
import { permissionsMiddleWare } from "../../../utils/permissionsMiddleWare";
export default {
  components: {
    DataTable,
    DateRangePicker,
    DropdownMenu,
    ConfirmDialog,
    ExportButtons
  },
  data() {
    return {
      filters: {
        start_date: formatedDate(),
        end_date: formatedDate()
      },
      id: "",
      columns: [
        { column: "serial", label: "#", width: "60" },
        {
          column: "date",
          label: "Reg Date",
          sortable: true
        },
        {
          column: "company",
          label: "Company",
          sortable: true
        },
        {
          column: "updated_at",
          label: "Processed date",
          sortable: true
        },
        {
          column: "status",
          label: "Status",
          sortable: true,
          ledger: true
        },
        { column: "action", label: "Action" }
      ]
    };
  },
  methods: {
    ...mapActions("doctors", ["companyList"]),
    ...mapActions("reports", ["reportLedgerDetails", "insurancePaid"]),
    handleDateRange(val) {
      this.filters.end_date = formatedDate(val.endDate);
      this.filters.start_date = formatedDate(val.startDate);
      this.reportLedgerDetails({
        id: this.$route.params.id,
        payload: this.filters
      });
    },
    exportInput() {
      return {
        title: `${
          this.patinetDetails && this.patinetDetails.name
            ? this.patinetDetails.name
            : ""
        } Ledger`,
        dateRange: {
          start: this.filters.start_date,
          end: this.filters.end_date
        },
        cols: this.columns,
        rows: this.reportLedger,
        fileName: "patient-ledger"
      };
    },
    handleExportPdf() {
      exportReportPdf(this.exportInput());
    },
    handleExportExcel() {
      exportReportExcel(this.exportInput());
    },
    handleRecieveables(val, rowData) {
      if (val == "Paid") {
        this.id = rowData.actions.history_id;
        this.$modal.show("confirmModal");
      }
    },
    handleSave() {
      if (permissionsMiddleWare("Insurance Paid")) {
        this.insurancePaid({ id: this.id, payload: this.filters });
        this.$modal.hide("confirmModal");
      } else {
        this.$toasted
          .info(
            "This action cannot be performed by you due to insufficient authorization. Action: Insurance Paid"
          )
          .goAway("3000");
      }
    },
    handleCancel() {
      this.$modal.hide("confirmModal");
      this.id = "";
    }
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      recieveablesReport: "reports/recieveablesReport",
      reportLedger: "reports/reportLedger",
      patinetDetails: "reports/patinetDetails",
      companyName: "doctors/companyName"
    }),
    sortOptions() {
      const arr = [];
      this.companyName.map(item => arr.push(item.name));
      arr.unshift("All");
      return arr;
    }
  },
  mounted() {
    this.companyList("company");
    this.reportLedgerDetails({
      id: this.$route.params.id,
      payload: this.filters
    });
  }
};
</script>

<style scoped>
.wrrapper {
  background: var(--canvas);
  min-height: 100vh;
}
</style>
